export function CustoSemIcms(custoRep: number, icms: number): number {
  const result = custoRep * (1 - icms / 100);
  return result;
}
